import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79df480d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallets container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Create Wallet"),
  /*#__PURE__*/_createElementVNode("p", null, "Past your exported private key ")
], -1))
const _hoisted_3 = { class: "private-key" }
const _hoisted_4 = { class: "derivation" }
const _hoisted_5 = { class: "mg-tabs" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "public", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "private", -1))
const _hoisted_9 = {
  key: 0,
  class: "form-group signer"
}
const _hoisted_10 = { class: "col-sm-10" }
const _hoisted_11 = { class: "signed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        value: '',
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updatePrivate && _ctx.updatePrivate(...args))),
        class: "phrase private-data",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        spellcheck: "false"
      }, "              \n        ", 32),
      _createElementVNode("div", {
        class: _normalizeClass(["warning", {hide:!_ctx.isValidKey}])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDerivation('btc'))),
            class: _normalizeClass({active:!_ctx.defaultDerivation.index})
          }, "BTC (legacy)", 2),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDerivation('segwit'))),
            class: _normalizeClass({active:_ctx.defaultDerivation.index == 1})
          }, "BTC segwit", 2),
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDerivation('eth'))),
            class: _normalizeClass({active:(_ctx.defaultDerivation.index == 2)})
          }, "ETH", 2)
        ])
      ]),
      (_ctx.isValidKey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString((_ctx.wallet.address)), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.address(_ctx.wallet.privateKey)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isValidKey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rootMessage) = $event)),
              class: "root-key private-data",
              autocomplete: "off",
              autocorrect: "off",
              autocapitalize: "off",
              spellcheck: "false"
            }, null, 512), [
              [_vModelText, _ctx.rootMessage]
            ])
          ]),
          _createElementVNode("button", {
            class: "",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSignMessage && _ctx.onSignMessage(...args)), ["stop"]))
          }, "Sign message"),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.signedMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}